import React from 'react';

const ThankYouModal = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-black bg-opacity-95 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl max-w-2xl w-full p-12 text-center shadow-2xl transform transition-all">
        <div className="mx-auto flex items-center justify-center h-24 w-24 rounded-full bg-gradient-to-br from-green-400 to-emerald-500 mb-6 shadow-lg">
          <svg className="h-14 w-14 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h2 className="text-4xl font-bold text-gray-900 mb-4">Thank You!</h2>
        <p className="text-xl text-gray-600 mb-8 leading-relaxed">
          We've received your booking and appreciate your trust in HOLONS.
        </p>
        <div className="bg-blue-50 rounded-lg p-6 mb-8">
          <p className="text-gray-700 text-lg">
            Our compassionate team will contact you shortly to confirm the details and guide you through the next steps.
          </p>
        </div>
        <button
          onClick={onClose}
          className="w-full px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white text-lg rounded-lg hover:from-blue-700 hover:to-purple-700 font-semibold shadow-lg transition transform hover:scale-105"
        >
          Close
        </button>
      </div>
    </div>
  );
};


export default ThankYouModal;
